import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useResponsive } from '@/hooks/use-responsive';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
const UserProfile = memo(() => {
  const {
    isMobile
  } = useResponsive();
  return <div className="relative flex items-center space-x-2">
      
      
      {!isMobile && <NavLink to="/admins" className="text-sm text-slate-400 hover:text-white transition-colors flex items-center">
          <Shield size={16} className="mr-2" />
          Admins
        </NavLink>}
    </div>;
});
UserProfile.displayName = 'UserProfile';
export default UserProfile;